import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import netlifyIdentity from 'netlify-identity-widget'
import GlobalNav from '../components/GlobalNav'
import { isLoggedIn } from '../helpers/auth'
import teamImage from '../images/team.svg'
import logo from '../images/parsable-logo.svg'
import './index.scss'
import 'flexboxgrid/dist/flexboxgrid.min.css'

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      isAuth: null,
    }
  }
  handleClick = e => {
    e.preventDefault()
    netlifyIdentity.open()
  }
  componentWillMount() {
    this.setState({ isLoading: true })
  }
  componentDidMount() {
    netlifyIdentity.init()
    this.setState({
      isAuth: isLoggedIn(),
      isLoading: false,
    })
    netlifyIdentity.on('login', user => {
      this.setState({ isAuth: true })
    })
    netlifyIdentity.on('logout', () => {
      this.setState({ isAuth: false })
    })
  }

  render() {
    if (!this.state.isLoading) {
      return (
        <div>
          {this.state.isAuth ? (
            <div>
              <GlobalNav />
              <main id="contentBody">
                <div>{this.props.children()}</div>
              </main>
            </div>
          ) : (
            <div className="login">
              <div className="login__brand">
                <img src={logo} />
              </div>
              <div className="login__image">
                <img src={teamImage} alt="" />
                <h3 className="login__tagline">
                  A single source of truth to help get work done right,
                  everytime. To get started, request an invitation from the
                  Design team. If you already have an account, simply login
                  below.
                </h3>
              </div>
              <div className="login__buttons">
                <Link
                  to="#"
                  className="button button--theme_primary"
                  onClick={this.handleClick}
                >
                  Login
                </Link>
              </div>
            </div>
          )}
        </div>
      )
    } else {
      return <h1>Loading</h1>
    }
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js